(function () {
  'use strict';
  function stateAt(setting, now, start, end) {
    if (setting !== 'auto') return setting;
    if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) return 'off';
    return now < start ? 'teaser' : now <= end ? 'live' : 'off';
  }
  function init(dialog) {
    if (dialog.dataset.initialized === 'true' || typeof dialog.showModal !== 'function') return;
    dialog.dataset.initialized = 'true';
    var preview = dialog.dataset.preview === 'true';
    var delay = Math.max(0, Number(dialog.dataset.delay) || 0) * 1000;
    var frequency = Math.max(0, Number(dialog.dataset.frequency) || 0) * 86400000;
    var seen = {}, pending = null, activeState = '', savedOverflow = '', lastFocus = null;
    var key = function () { return 'lwes-trick-or-test-2026-' + dialog.dataset.mode; };
    function suppressed() {
      if (preview || window.Shopify && window.Shopify.designMode) return false;
      try { var timestamp = Number(localStorage.getItem(key())); return timestamp > 0 && Date.now() - timestamp < frequency; }
      catch (_) { return false; }
    }
    function open() {
      if (dialog.dataset.mode === 'off' || dialog.open || !preview && suppressed()) return;
      if (document.querySelector('dialog[open]')) { pending = setTimeout(open, 1000); return; }
      lastFocus = document.activeElement;
      savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
      seen[dialog.dataset.mode] = true;
    }
    function close(dismissed) {
      if (!dialog.open) return;
      if (dismissed && !preview) {
        try { localStorage.setItem(key(), String(Date.now())); } catch (_) {}
      }
      document.body.style.overflow = savedOverflow;
      dialog.close();
      if (lastFocus && lastFocus.isConnected && lastFocus.focus) lastFocus.focus();
    }
    dialog.addEventListener('close', function () {
      if (dialog.open) return; // Ignore an older close event after a rapid reopen.
      document.body.style.overflow = savedOverflow;
      if (lastFocus && lastFocus.isConnected && lastFocus.focus) lastFocus.focus();
    });
    function sync() {
      var state = stateAt(dialog.dataset.settingMode, Date.now(), Date.parse(dialog.dataset.start), Date.parse(dialog.dataset.end));
      var changed = state !== activeState;
      dialog.dataset.mode = state;
      var ready = state === 'live' && dialog.dataset.fnpLive === 'true';
      dialog.querySelectorAll('[data-show]').forEach(function (node) {
        var target = node.dataset.show;
        node.hidden = !(target === state || target === 'fnp' && ready || target === 'pending' && state === 'live' && !ready);
      });
      if (changed) {
        clearTimeout(pending);
        activeState = state;
        if (state === 'off') close(false);
        else if (!dialog.open && !seen[state] && !suppressed()) pending = setTimeout(open, preview || window.Shopify && window.Shopify.designMode ? 0 : delay);
      }
    }
    dialog.querySelectorAll('[data-ttp-close]').forEach(function (button) { button.addEventListener('click', function () { close(true); }); });
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(true); });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(true);
    });
    dialog.querySelectorAll('.ttp-actions a').forEach(function (link) { link.addEventListener('click', function () { close(true); }); });
    dialog.querySelector('[data-ttp-copy]').addEventListener('click', async function (event) {
      var button = event.currentTarget, feedback = dialog.querySelector('.ttp-feedback');
      try {
        if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(button.dataset.code);
        button.textContent = 'Copied ✓'; feedback.textContent = 'Code copied. Use it at checkout during October 15–31.';
      } catch (_) {
        var range = document.createRange(); range.selectNodeContents(dialog.querySelector('.ttp-code'));
        var selection = window.getSelection(); if (selection) { selection.removeAllRanges(); selection.addRange(range); }
        button.textContent = 'Select code'; feedback.textContent = 'Copy the selected code manually: ' + button.dataset.code;
      }
    });
    document.querySelectorAll('[data-ttp-open]').forEach(function (button) { button.addEventListener('click', open); });
    sync();
    var timer = setInterval(function () {
      if (dialog.isConnected) sync();
      else { clearInterval(timer); clearTimeout(pending); if (dialog.open) document.body.style.overflow = savedOverflow; }
    }, 1000);
  }
  document.querySelectorAll('[data-ttp]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-ttp]').forEach(init); });
})();
